import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'src/app/components/icon/icon.module';

import { CookiesBannerComponent } from './cookies-banner.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  imports: [CommonModule, FormsModule, ButtonModule, IconModule],
  declarations: [CookiesBannerComponent],
  exports: [CookiesBannerComponent],
})
export class CookiesBannerModule {}
